import { render, staticRenderFns } from "./view-buyer-dialog.vue?vue&type=template&id=15664f92&scoped=true"
import script from "./view-buyer-dialog.vue?vue&type=script&lang=js"
export * from "./view-buyer-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-buyer-dialog.vue?vue&type=style&index=0&id=15664f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15664f92",
  null
  
)

export default component.exports